import { fetchList } from '@/api/merchant/industry'
import { dataToOpts } from '@/utils/opts'
import _ from 'lodash'

const query = {
  limit: 1000,
  sort: 'id'
}

const industry = {
  state: {
    list: [],
    data: {},
    inited: false
  },

  mutations: {
    INIT_INDUSTRY: (state, data) => {
      state.inited = true
      state.data = dataToOpts(data)
      state.list = _.cloneDeep(state.data.opts)
    }
  },

  actions: {
    InitIndustry ({ commit }) {
      if (this.state.industry.inited) {
        return new Promise((resolve) => {
          resolve(this.state.industry.data)
        })
      }
      return new Promise((resolve, reject) => {
        fetchList(query).then(res => {
          commit('INIT_INDUSTRY', res.data)
          resolve(this.state.industry.data)
        }).catch((err) => {
          reject(err)
        })
      })
    }
  }
}

export default industry
